/* YUMIS product page: size chart on the size row, dropdowns closed by default, smart phone sticky bar */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var info = document.querySelector('.product__section-right .sticky--content');
    if (!info) return;

    /* Size chart sits on the same row as "Size" (the size chart block is placed by another script, so retry) */
    function placeGuide() {
      var variants = info.querySelector('.product-form__variants');
      var guide = document.querySelector('.yumis-sizeguide');
      if (!variants || !guide) return false;
      if (guide.parentElement !== variants) { variants.classList.add('ypd-has-guide'); variants.appendChild(guide); }
      return true;
    }
    /* Detail dropdowns start closed, so the buying area stays compact */
    var closed = false;
    function closeAccs() {
      if (closed) return true;
      var accs = info.querySelectorAll('.yumis-accs details.yumis-acc');
      if (!accs.length) return false;
      accs.forEach(function (d) { d.removeAttribute('open'); });
      closed = true;
      return true;
    }
    var tries = 0;
    (function retry() {
      var a = placeGuide(), b = closeAccs();
      if ((!a || !b) && tries++ < 30) setTimeout(retry, 250);
    })();
    window.addEventListener('load', function () { placeGuide(); closeAccs(); });

    /* Phone sticky bar: shows once the main button has scrolled above the screen.
       The WhatsApp bubble is lifted above the bar while it shows. */
    var btn = info.querySelector('.js-ajax-submit');
    var sticky = document.querySelector('.yumis-sticky-atc');
    function liftChat(show) {
      var host = document.querySelector('whatsapp-chat-by-squadkin');
      var wrap = host && host.shadowRoot && host.shadowRoot.querySelector('.squadkin-wrapper-container');
      if (!wrap) return;
      if (show) wrap.style.setProperty('--sk-bottom', (sticky.offsetHeight + 16) + 'px');
      else wrap.style.removeProperty('--sk-bottom');
    }
    if (sticky && btn) {
      var ticking = false;
      function sync() {
        ticking = false;
        var phone = window.matchMedia('(max-width: 1023px)').matches;
        var show = phone && btn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('ypd-show', show);
        liftChat(show);
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    }
  });
})();

/* Sold out state on the product page: marks the buying area as sold out only when the chosen size is really
   unavailable (button disabled AND says Sold Out/Unavailable), so nothing turns grey while "Adding..." */
(function () {
  function init() {
    var right = document.querySelector('.product__section-right');
    var main = right && right.querySelector('.js-ajax-submit');
    if (!main) return;
    var price = right.querySelector('#product-price');
    function sync() {
      var label = (main.textContent || '').trim().toLowerCase();
      if (!main.disabled && label.indexOf('sold') === -1 && label.indexOf('unavailable') === -1) {
        right.classList.remove('ypd-soldout');
        if (price) price.classList.remove('price--sold-out');
        return;
      }
      if (main.disabled && (label.indexOf('sold') > -1 || label.indexOf('unavailable') > -1)) {
        right.classList.add('ypd-soldout');
        if (price) price.classList.add('price--sold-out');
      }
      /* any other disabled state (e.g. "Adding...") leaves the current look unchanged */
    }
    sync();
    new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
